export default __webpack_public_path__ + "static/media/BA13.0edd8518.jpg";